import React, { FC } from 'react';
import { Form, Radio, Whisper, Tooltip } from 'rsuite';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import { Link } from 'react-router-dom';
import { CustomTooltip } from '../../file-list/FileListPage';
import { Typography } from '@mui/material';

const CustomHelperTextError = () => (
  <div
    style={{
      color: 'red',
      display: 'flex',
      alignItems: 'center',
      margin: '4px 0',
    }}
  >
    <ErrorOutlineOutlinedIcon style={{ marginRight: '4px' }} />
    <span>This field is required</span>
  </div>
);

export const CustomContactForm: FC = (inputData: any) => {
  const { fields, checkEmptyForm } = inputData;
  return (
    <>
      {fields.map(
        ({
          name,
          Component,
          data,
          value,
          onChange,
          props,
          type,
          ...ratioProps
        }) => {
          if (type === 'ratioWrapper') {
            return (
              <>
                <Radio
                  name={ratioProps.ratioName}
                  value={ratioProps.ratioVal}
                  onChange={ratioProps.ratioHandler}
                  checked={ratioProps.currentVal === ratioProps.ratioVal}
                >
                  {ratioProps.ratioTitle}
                </Radio>
                {ratioProps.currentVal === ratioProps.ratioVal && (
                  <Form.Group
                    style={{
                      padding: '2rem 1rem',
                      backgroundColor: '#72FFFF',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                    }}
                  >
                    <Form.ControlLabel>{name}</Form.ControlLabel>
                    <Component
                      data={data}
                      value={value}
                      onChange={onChange}
                      {...props}
                    />
                    {/* {name === 'SMS Template' && (
                      <Link
                        to='/templates'
                        style={{
                          fontSize: '0.8rem',
                          display: 'block',
                          margin: '0.3rem',
                        }}
                      >
                        Add new SMS template
                      </Link>
                    )} */}
                    {checkEmptyForm && !value && <CustomHelperTextError />}
                  </Form.Group>
                )}
              </>
            );
          }

          if (type === 'checkboxWrapper') {
            return (
              <Form.Group>
                <Component checked={value} onChange={onChange} {...props}>
                  {name}
                </Component>
                <CustomTooltip
                  title={
                    <Typography style={{ zIndex: '100000' }} width="240px">
                      MMS messages can only be sent within the US and Canada
                    </Typography>
                  }
                  placement="bottom-start"
                  arrow
                >
                  <HelpOutlineIcon style={{ marginLeft: '5px' }} />
                </CustomTooltip>
                {checkEmptyForm && !value && <CustomHelperTextError />}
              </Form.Group>
            );
          }

          return (
            <Form.Group>
              <Form.ControlLabel>{name}</Form.ControlLabel>
              <Component
                data={data}
                value={value}
                onChange={onChange}
                {...props}
              />
              {/* {name === 'Email Template' && (
                <Link
                  to="/templates"
                  style={{
                    fontSize: '0.8rem',
                    display: 'block',
                    margin: '0.3rem',
                  }}
                >
                  Add new email template
                </Link>
              )} */}
              {checkEmptyForm && !value && <CustomHelperTextError />}
            </Form.Group>
          );
        }
      )}
    </>
  );
};
